module.exports = __webpack_public_path__ + "media/img/quest-309cc609cff3abb0770ec3d85222d6d9.svg";